export default __webpack_public_path__ + "static/media/Hero-Picture 9 - without text.933da7db.gif";